import { get } from './request';

export async function fetchAuth0OrganizationId (
  userService,
  _,
  { organizationName }
) {
  const url = `${userService}/trueprodigy/user/auth0/organization/id?organizationName=${organizationName}`;
  const { body } = await get(null, url);
  return body;
}
